/**
 * TipTap Editor Initialization
 * ES Module that imports TipTap from node_modules and exposes it as globals
 * This file gets bundled by scripts/build-npm-bundles.js
 */

// Core editor
import { Editor } from '@tiptap/core';

// Starter kit and basic extensions
import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Underline from '@tiptap/extension-underline';

// Table extensions
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';

// Code block with syntax highlighting
import { CodeBlockLowlight } from '@tiptap/extension-code-block-lowlight';
import { common, createLowlight } from 'lowlight';

// Image extension
import Image from '@tiptap/extension-image';

// Text formatting extensions
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';

// Create lowlight instance
const lowlight = createLowlight(common);

// Expose TipTap Editor as global
window.TiptapEditor = Editor;

// Expose all extensions as a single global object
window.TiptapExtensions = {
  StarterKit,
  Link,
  Underline,
  Superscript,
  Subscript,
  Table,
  TableRow,
  TableCell,
  TableHeader,
  CodeBlockLowlight,
  Image,
  lowlight
};
